var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "table-component",
        {
          ref: "table",
          attrs: {
            tableDivId: _vm.tableDivId,
            "show-filter": false,
            data: _vm.fetchData,
            "table-class": "table",
          },
        },
        [
          _c("table-column", {
            attrs: { label: _vm.$t("actions.name"), show: "name" },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("actions.updated_at"), show: "updated_at" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }